export function transformRectangle(rect: DOMRect, matrix: DOMMatrix) {
    // 1. Extract the four corner points as DOMPoint objects.
    const topLeft = new DOMPoint(rect.x, rect.y);
    const topRight = new DOMPoint(rect.x + rect.width, rect.y);
    const bottomLeft = new DOMPoint(rect.x, rect.y + rect.height);
    const bottomRight = new DOMPoint(rect.x + rect.width, rect.y + rect.height);

    // 2. Transform each point using the matrixTransform() method.
    // The original points are not modified.
    const transformedTopLeft = topLeft.matrixTransform(matrix);
    const transformedTopRight = topRight.matrixTransform(matrix);
    const transformedBottomLeft = bottomLeft.matrixTransform(matrix);
    const transformedBottomRight = bottomRight.matrixTransform(matrix);

    // 3. Calculate the new bounding box's minimum and maximum coordinates.
    const minX = Math.min(transformedTopLeft.x, transformedTopRight.x, transformedBottomLeft.x, transformedBottomRight.x);
    const maxX = Math.max(transformedTopLeft.x, transformedTopRight.x, transformedBottomLeft.x, transformedBottomRight.x);
    const minY = Math.min(transformedTopLeft.y, transformedTopRight.y, transformedBottomLeft.y, transformedBottomRight.y);
    const maxY = Math.max(transformedTopLeft.y, transformedTopRight.y, transformedBottomLeft.y, transformedBottomRight.y);

    // 4. Create and return a new DOMRect with the new bounding box dimensions.
    return DOMRect.fromRect({
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    });
}
